import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';

interface IRefreshPageDialogProps {}

let RefreshPageDialog: React.ComponentType<IRefreshPageDialogProps> = () => {
  const [disabled, setDisabled] = React.useState(false);
  const handleClick = React.useCallback(() => {
    setDisabled(true);
    location.reload();
  }, []);
  const handleClose = React.useCallback(() => {
    // we don't do anything, to close the dialog, we want to force them to click the reload button
  }, []);

  return (
    <Dialog open onClose={handleClose} disableBackdropClick>
      <DialogTitle>New Version Available</DialogTitle>
      <DialogContent>
        <DialogContentText>A new version of Mia has been released. Click Refresh to update.</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClick} color="primary" variant="contained" disabled={disabled}>
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};

RefreshPageDialog = React.memo(RefreshPageDialog);
export { RefreshPageDialog };
